export enum ValidationErrorTypeOf {
  CLIENT_ADDRESS_DELETE_RESPONSIBLE_MUNICIPALITY_CONFLICT = 'client_address_delete_responsible_municipality_conflict',
  CLIENT_ADDRESS_BOUNDED_PERIOD_OVERLAP = 'client_address_bounded_period_overlap',
  CLIENT_ADDRESS_END_DATE_CONFLICT = 'client_address_end_date_conflict',
  CLIENT_ADDRESS_MULTIPLE_PERIOD_OVERLAP = 'client_address_multiple_period_overlap',
  CLIENT_ADDRESS_START_DATE_CONFLICT = 'client_address_start_date_conflict',
  DUPLICATE_CLIENT_BSN = 'duplicate_client_bsn',
  LINKED_ROUND_ROBIN_SUPPLIER_CONFLICT = 'linked_round_robin_supplier_conflict',
}
